import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { Col, Row } from "react-bootstrap";
import styles from "./TopUpModals.module.scss";
import React, { useEffect, useState } from "react";
import Button from "../../../../common/Button/Button";
import Modal from "../../../../common/Modals/Modal/Modal";
import { STATUS_CODE } from "../../../../../utils/constants";
import Select from "../../../../common/Formik/Select/Select";
import InputFormik from "../../../../common/Formik/Input/InputFormik";
import TransferSuccessfulModal from "./TransferSuccessfulModal/TransferSuccessfulModal";
import { getActiveCoinAction, topUpCardAction } from "../../../../../features/user/userSlice";

const TopUpModals = ({ show, handleClose, cardId, setUpdate }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [topUpData, setTopUpData] = useState({})
    const [activeCoins, setActiveCoins] = useState([]);
    const [showProcess, setShowProcess] = useState(false);

    /* ===================== FORMIK ===================== */

    const validationSchema = Yup.object({
        amount: Yup.number()
            .required('Amount is required')
            .min(1, 'Amount must be at least 1')
            .typeError('Amount must be a number')
            .integer('Decimal values are not allowed')
            .max(10000, 'Amount must be at most 10000'),
    });
    const formik = useFormik({
        initialValues: {
            coin: null,
            amount: "",
        },
        validationSchema,
        onSubmit: (values) => {
            topUpCard(values)
            // handleClose();
        },
    });

    /* ===================== PRICE SHORTCUTS ===================== */
    const pricelist = [
        { value: "+10" },
        { value: "+50" },
        { value: "+100" },
        { value: "Max" },
    ];

    /* ===================== FETCH COINS ===================== */
    const fetchCoinOptions = async () => {
        try {
            const response = await dispatch(
                getActiveCoinAction({ filter: "TOKEN" })
            );
            if (response?.data?.status === STATUS_CODE.successful) {
                const options = response?.data?.data?.coinList?.map((coin) => ({
                    value: coin.coin_name,
                    label: coin.coin_name,
                    balance: coin.balance,
                    symbol: coin.coin_symbol,
                })) || [];

                setActiveCoins(options);
                if (options.length > 0) {
                    formik.setFieldValue("coin", options[0]);
                }
            }
        } catch (error) {
            console.log("Error fetching coin options", error);
        }
    };

    useEffect(() => {
        fetchCoinOptions();
    }, []);

    const topUpCard = async (values) => {
        setLoading(true);
        try {
            const payload = {
                cryptoAsset: values.coin.value,
                amount: values.amount
            }
            const res = await dispatch(topUpCardAction(payload, cardId))
            if (res?.data?.status === STATUS_CODE.successful) {
                setTopUpData(res?.data?.data)
                setUpdate((prev) => !prev);
                setShowProcess(true);
            }
        } catch (error) {
            console.log(error, "error");
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                title="Top Up Card"
                className={styles.topupModal}
            >
                <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <Row>
                        {/* ===================== COIN SELECT ===================== */}
                        <Col lg={12}>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                {/* <label className="form-label mb-0">Select Asset</label> */}
                                {formik.values.coin && (
                                    <span
                                        style={{
                                            fontSize: "13px",
                                            color: "#6f6eff",
                                            fontWeight: 500,
                                        }}
                                    >
                                        Bal: {parseFloat(formik.values.coin.balance).toFixed(3)}{" "}
                                        {formik.values.coin.symbol}
                                    </span>
                                )}
                            </div>

                            <Select
                                variant="xlarge_height"
                                className="select_time"
                                label="Coin"
                                name="coin"
                                options={activeCoins}
                                value={formik.values.coin}
                                onChange={(option) =>
                                    formik.setFieldValue("coin", option)
                                }
                                isSearchable={false}
                                isDisabled={loading}
                                placeholder={loading ? "Loading coins..." : "Select coin"}
                            />
                        </Col>

                        {/* ===================== AMOUNT INPUT ===================== */}
                        <Col lg={12}>
                            <InputFormik
                                variant="large_height"
                                name="amount"
                                label="Amount"
                                placeholder="Enter amount"
                                className="fieldinput"
                                {...formik.getFieldProps("amount")}
                                formik={formik}
                                onKeyDown={(e) => {
                                    if (e.key === '.' || e.key === 'e' || e.key === 'E') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Col>
                    </Row>

                    {/* ===================== QUICK AMOUNTS ===================== */}
                    <ul className={styles.listtop}>
                        {pricelist.map((item, index) => (
                            <li
                                key={index}
                                onClick={() => {
                                    if (item.value === "Max") {
                                        // example max logic
                                        formik.setFieldValue("amount", "10000");
                                    } else {
                                        const val = item.value.replace("+", "");
                                        formik.setFieldValue("amount", val);
                                    }
                                }}
                            >
                                <h6>{item.value}</h6>
                            </li>
                        ))}
                    </ul>

                    {/* ===================== SUBMIT ===================== */}
                    <Button
                        fluid
                        className={styles.btn_size}
                        type="button"
                        disabled={!formik.values.coin || !formik.values.amount || loading}
                        onClick={(e) => {
                            formik.handleSubmit(e);
                        }}
                    >
                        {loading ? "Processing..." : "Review Top Up"}
                    </Button>
                </form>
            </Modal>

            {/* ===================== PROCESSING MODAL ===================== */}
            {showProcess &&
                < TransferSuccessfulModal
                    show={showProcess}
                    handleClose={() => setShowProcess(false)}
                    topUpData={topUpData}
                    previousModalClose={handleClose}
                />}
        </>
    );
};

export default TopUpModals;